import { SearchOptions } from '@algolia/client-search';
import { SearchIndex } from 'algoliasearch';

import client from './searchClient';
import { BoulderHit } from './hitTypes'
import { boulderIndex } from './indeces';


export interface BoulderFilters {
  ancestryId?: string;
}

export class BoulderSearch {
  filters?: BoulderFilters;
  text?: string;
  page?: number;
  maxPage?: number;

  private _index: SearchIndex;
  private _privileged: boolean;

  constructor(privileged=false) {
    this._index = client.initIndex(boulderIndex());
    this._privileged = privileged;
  }

  filterBy(filters: BoulderFilters) {
    this.filters = filters;
    return this;
  }

  setText(s: string) {
    this.text = s;
    return this;
  }

  pageTo(page: number) {
    this.page = page;
    return this;
  }

  limitTo(max: number) {
    this.maxPage = max;
    return this;
  }

  private _convertFilters(filters: BoulderFilters): string {
    const outerFilters: string[] = [];

    // ancestry filters
    if (filters.ancestryId) {
      outerFilters.push(`(_ancestryIds:${filters.ancestryId})`)
    }
    // end ancestry filters

    // public filters
    if (!this._privileged) {
      outerFilters.push(`(public:true)`);
    }
    // end public filters

    // combine filters
    return outerFilters.join(' AND ');
  }

  async get() {
    const searchOptions: SearchOptions = {
      page: this.page ?? 0,
      hitsPerPage: this.maxPage ?? 10,
      filters: this.filters ? this._convertFilters(this.filters) : undefined
    };

    let { hits, nbPages, page, nbHits } = await this._index.search(this.text ?? '', searchOptions);

    return ({
      hits: hits as BoulderHit[],
      page: page,
      pages: nbPages,
      nbHits: nbHits
    });
  }
}

